import { render, staticRenderFns } from "./ModalCustomerMessageTemplate.vue?vue&type=template&id=08ea3cbc"
import script from "./ModalCustomerMessageTemplate.vue?vue&type=script&lang=js"
export * from "./ModalCustomerMessageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports